"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerViewModel = void 0;
const tsyringe_1 = require("tsyringe");
const BaseViewModel_1 = require("../../core/render/BaseViewModel");
const RelayCommand_1 = require("../../core/render/RelayCommand");
const globalSymbols_1 = require("../../globalSymbols");
let PlayerViewModel = class PlayerViewModel extends BaseViewModel_1.BaseViewModel {
    constructor(logger, songManager, resourceManager) {
        super();
        this.logger = logger;
        this.songManager = songManager;
        this.resourceManager = resourceManager;
        this.togglePlayer = new RelayCommand_1.RelayCommand(() => true, () => this.togglePlayerEvent());
    }
};
PlayerViewModel = __decorate([
    tsyringe_1.injectable(),
    __param(0, tsyringe_1.inject(globalSymbols_1.TLogger)), __param(1, tsyringe_1.inject(globalSymbols_1.TSongManager)), __param(2, tsyringe_1.inject(globalSymbols_1.TResourceManager)),
    __metadata("design:paramtypes", [Object, Object, Object])
], PlayerViewModel);
exports.PlayerViewModel = PlayerViewModel;
//# sourceMappingURL=PlayerViewModel.js.map